import { GetLockerMetricsState } from './getLockerMetrics.types'

const getLockerMetricsInitialState: GetLockerMetricsState = {
  loading: false,
  error: null,
  success: null
}

export default getLockerMetricsInitialState
